import React, { useState, useEffect } from "react";
import { Grid, Box } from "@mui/material";
import SideBar from "../../components/Sidebar/index";
import { Card, Space, Button, Tag } from "antd";
import Table from "../../components/Table/Index";
import { queenApiCalling } from "../../constant/API";
import { ToastContainer, toast } from "react-toastify";
import "../../css/main.css";

export default function CategoryGenres() {
  const [data, setData] = useState([]);
  const [col, setCol] = useState([
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Genre",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Event Category",
      dataIndex: "category_name",
      key: "category_name",
    },
    {
      title: "Action",

      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type={"success"}
            href={
              "/editEventGenres/" + _.id + "/" + _.name + "/" + _.category_id
            }
            style={{ background: "#fbc531", color: "#FFFFFF" }}
          >
            Edit
          </Button>

          <Button danger onClick={() => deleteEventCategory(_.id)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ]);

  const deleteEventCategory = (id) => {
    let params = { id: id, action: "DELETE_EVENT_GENRES" };
    queenApiCalling(params).then((res) => {
      if (res.status === "success") {
        toast.success(res.message);
        getEventGenres();
      } else {
        toast.error(res.message);
      }
    });
  };

  const getEventGenres = () => {
    queenApiCalling({ action: "GET_EVENT_GENRES" }).then((res) => {
      if (Array.isArray(res)) {
        setData(res);
      }
    });
  };

  useEffect(() => {
    getEventGenres();
  }, []);

  return (
    <Box>
      <Grid>
        <></>
      </Grid>
      <Box md={{ width: "100%" }} style={{ marginTop: "0px" }}>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
          sx={{ flexDirection: { xs: "column", md: "row" } }}
        >
          <Grid item md={2}>
            <SideBar type={localStorage.getItem("adminSession").role} />
          </Grid>
          <Grid
            md={10}
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            sx={{ flexDirection: { xs: "column", md: "row" } }}
            style={{ marginTop: "0px" }}
          >
            <Card
              title="Event Genre Listing"
              extra={
                <Button
                  href="/createEventGenres"
                  style={{ background: "#5f27cd", color: "#FFFFFF" }}
                >
                  Create Event Genre
                </Button>
              }
              style={{
                width: "98%",
                marginLeft: "1%",
                marginTop: "30px",
              }}
            >
              <Table data={data} col={col} />
            </Card>
          </Grid>
        </Grid>
      </Box>
      <ToastContainer />
    </Box>
  );
}
